import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';

var MultiStepWrapper = function MultiStepWrapper(props) {
  var _props$query;

  var children = props.children,
      totalSteps = props.totalSteps,
      formName = props.schema.formName;

  var _useState = useState(parseInt((_props$query = props.query) === null || _props$query === void 0 ? void 0 : _props$query.position, 10) || 0),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var numberOfSections = totalSteps && totalSteps - 1 || children.length || 0;

  var _useState3 = useState(new Array(totalSteps).fill(false)),
      _useState4 = _slicedToArray(_useState3, 2),
      completionState = _useState4[0],
      setCompletionState = _useState4[1];

  var goToPage = function goToPage(index) {
    if (isNaN(index)) return;
    index = Math.max(0, index);
    index = Math.min(index, numberOfSections);
    setActiveIndex(index);
    var scrollOffset = 20;
    var formElement = document.querySelector("form[name=multi-step-".concat(formName)).children[index];
    var formPosition = formElement.getBoundingClientRect().top;
    var offsetPosition = formPosition - scrollOffset + window.scrollY;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };

  var goToUrl = function goToUrl(url) {
    if (url) {
      var trackEvent = props.trackEvent;
      var trackingObj = {
        tracking: {
          category: {
            value: 'Site Interaction'
          },
          action: {
            value: 'Redirection from form'
          },
          label: {
            value: "Redirected to ".concat(url)
          }
        }
      };
      trackEvent(trackingObj);
      window.location.href = url;
    }
  };

  var goToFirst = function goToFirst() {
    return goToPage(0);
  };

  var goForward = function goForward() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return goToPage(activeIndex + n);
  };

  var goBack = function goBack() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return goToPage(activeIndex - n);
  };

  var goToLast = function goToLast() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return goToPage(numberOfSections - n);
  };

  var updateCompletionState = function updateCompletionState(index) {
    var isComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    completionState[index] = isComplete;
    return setCompletionState(completionState);
  }; // change this to a better name - complete stage concept


  var editFromSummary = function editFromSummary() {
    var trackEvent = props.trackEvent;
    var trackingObj = {
      tracking: {
        category: {
          value: 'Site Interaction'
        },
        action: {
          value: 'Form step complete'
        },
        label: {
          value: activeIndex
        }
      }
    };
    trackEvent(trackingObj);

    if (completionState[activeIndex + 1]) {
      return goToLast(0);
    }

    return goForward();
  };

  return React.Children.map(props.children, function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, props), {}, {
      goToFirst: goToFirst,
      goForward: goForward,
      goBack: goBack,
      goToLast: goToLast,
      goToPage: goToPage,
      goToUrl: goToUrl,
      index: index,
      setActiveIndex: setActiveIndex,
      activeIndex: activeIndex,
      completionState: completionState,
      updateCompletionState: updateCompletionState,
      editFromSummary: editFromSummary
    }));
  });
};

export default MultiStepWrapper;
//# sourceMappingURL=multi-step.js.map